import { type Transition, type Variants } from 'framer-motion';

import { framerMotion } from '@pkg/primitives';

import { tokens } from './Drawer.tokens';

///
/// Drawer Wrapper

export enum DrawerVariant {
    Hidden = 'hidden',
    Show = 'show',
}

export const drawerVariants: Variants = {
    [DrawerVariant.Hidden]: {
        opacity: 0,
        translateY: tokens.drawer.offsetY,
    },
    [DrawerVariant.Show]: {
        opacity: 1,
        translateY: 0,
    },
};

export const drawerTransition: Transition = {
    ease: framerMotion.easing.cubic,
    duration: framerMotion.duration.slow,
};

///
/// Backdrop

export const backdropTransition: Transition = {
    ease: 'easeInOut',
    duration: framerMotion.duration.slow,
};
